import Vue from 'vue';
import Vuex from 'vuex';

import axios from 'axios';
import visualization from './store/modules/visualization';

// eslint-disable-next-line import/extensions
// import dataWorker from './web-workers/data.worker.js';

Vue.use(Vuex);
const store = new Vuex.Store({
  modules: {
    visualization,
  },
  state: {
    // Webmap shared state
    webmap: null,
    // sites: null,
    // cables: null,
    currentSite: '',
    filteredCatalog: [],
    instCheckboxSelection: [],
    infraCheckboxSelection: [],
    daModal: null,
    daModalLoading: false,
    instDetailsLoading: false,
    // areas: null,
    selectedArea: null,

    // Annotations
    annotations: [],
    chartAnnotations: [],
    annotationStatus: null,

    // Application
    // loaded: false,
    notLoaded: false,
    progressVal: 0,

    // Dismissable Alert
    showDismissibleAlert: true,

    // Instrument and Infrastructure status
    statusIndicators: null,
    infraIndicators: null,

    /* OVERHAUL NEW SHARED STATES */
    // Initial Metadata
    cables: null,
    instruments: null,
    sites: null,
    areas: null,
    globalRanges: null,
    infrastructures: null,
    dataPortalPosts: null,
    parameters: null,
    instrumentsCatalog: null,
    spriteIcons: null,

    // Shared main map state
    mainMap: null,
    mapSelectedInfra: null,
    mapSelectedInst: null,
    wpContentSelectedInfra: null,
    selectedInfraList: [],
    selectedInstrumentList: [],
    selectedBathymetryLayers: [],
    instrumentDetailModals: {},
    currentBaseMapScheme: 'standard',
    bathymetryInView: [],
    showSidebar: false,
    sidebarContent: '',

    // App load state
    loaded: false,
    /* -------------------------- */
  },
  /**
   * Cannot directly mutate a store's state, therefore,
   * Only way to change a store's state is through committing mutations
   * Each mutation has a string type and a handler. The handler function is
   * where we perform actual state modifications, and it will receive the
   * state as the first argument.
   */
  mutations: {
    /* OVERHAUL NEW MUTATIONS */
    // Initial Metadata
    STORE_CABLES: (state, cables) => {
      state.cables = cables;
    },
    STORE_INSTRUMENTS: (state, instruments) => {
      state.instruments = instruments;
    },
    STORE_SITES: (state, sites) => {
      state.sites = sites;
    },
    STORE_AREAS: (state, areas) => {
      state.areas = areas;
    },
    STORE_INFRAS: (state, infras) => {
      state.infrastructures = infras;
    },
    STORE_PARAMETERS: (state, parameters) => {
      state.parameters = parameters;
    },
    STORE_GLOBAL_RANGES: (state, globalRanges) => {
      state.globalRanges = globalRanges;
    },
    STORE_INSTRUMENT_STATUS: (state, statusIndicators) => {
      state.statusIndicators = statusIndicators;
    },
    STORE_INFRASTRUCTURE_STATUS: (state, infraIndicators) => {
      state.infraIndicators = infraIndicators;
    },
    STORE_INSTRUMENTS_CATALOG: (state, instrumentsCatalog) => {
      state.instrumentsCatalog = instrumentsCatalog;
    },
    STORE_SPRITE_ICONS: (state, spriteIcons) => {
      state.spriteIcons = spriteIcons;
    },
    STORE_DATA_PORTAL_POSTS: (state, dataPortalPosts) => {
      state.dataPortalPosts = dataPortalPosts;
    },
    MAP_SELECT_INFRA: (state, infrastructure) => {
      state.mapSelectedInfra = infrastructure;
    },
    TOGGLE_SIDEBAR: (state, showSidebar) => {
      state.showSidebar = showSidebar;
    },
    DETERMINE_SIDEBAR_CONTENT: (state, sidebarContent) => {
      state.sidebarContent = sidebarContent;
    },
    MAP_SELECT_INST: (state, instrument) => {
      state.mapSelectedInst = instrument;
    },
    SET_INFRA_WP_CONTENT: (state, wpContent) => {
      state.wpContentSelectedInfra = wpContent;
    },
    SET_SELECTED_INFRA: (state, selected) => {
      state.selectedInfraList = selected;
    },
    SET_SELECTED_INSTRUMENT: (state, selected) => {
      state.selectedInstrumentList = selected;
    },
    SET_BATHYMETRY_LAYERS: (state, selected) => {
      state.selectedBathymetryLayers = selected;
    },
    SET_INSTRUMENT_MODALS: (state, refs) => {
      state.instrumentDetailModals = refs;
    },
    SET_CURRENT_BASEMAP_SCHEME: (state, scheme) => {
      state.currentBaseMapScheme = scheme;
    },
    SET_BATHYMETRY_IN_VIEW: (state, layers) => {
      state.bathymetryInView = [...layers];
    },

    // App load state
    APP_LOADED: (state) => {
      state.loaded = true;
    },
    APP_NOT_LOADED: (state) => {
      state.loaded = false;
    },
    UPDATE_PROGRESS: (state, val) => {
      state.progressVal = val;
    },
    /* ---------------------------- */
    // Used in main.js
    appReady: (state) => {
      state.loaded = true;
    },
    appNotReady: (state) => {
      state.notLoaded = true;
    },
    updateProgress: (state, val) => {
      state.progressVal += val;
    },
    updateInstrumentsCatalog: (state, instrumentsCatalog) => {
      state.instrumentsCatalog = instrumentsCatalog;
    },
    // Used in Popup.vue and MapDetails.vue
    setdaModalLoading: (state) => {
      state.daModalLoading = true;
    },
    // Used in MapDetails.vue
    setinstDetailsLoading: (state) => {
      state.instDetailsLoading = true;
    },
    setinstDetailsNotLoading: (state) => {
      state.instDetailsLoading = false;
    },
    // Used in MapApp.vue
    setdaModal: (state, daModal) => {
      state.daModal = daModal;
    },
    // Used in DAModal.vue
    setdaModalNotLoading: (state) => {
      state.daModalLoading = false;
    },
    // Used in FeedbackAlert.vue
    alertDismissed: (state) => {
      state.showDismissibleAlert = false;
    },
    // Used in Area.vue
    setSelectedArea: (state, area) => {
      state.selectedArea = area;
    },
    // Used in SearchBar.vue
    updateSearchResult: (state, results) => {
      state.filteredCatalog = results;
    },
    // Used in Instruments.vue, saves inst checkbox selection
    updateInstCheckbox: (state, results) => {
      state.instCheckboxSelection = results;
    },
    // Used in Infrastructures.vue, saves infra checkbox selection
    updateInfraCheckbox: (state, results) => {
      state.infraCheckboxSelection = results;
    },
    // Used in WebMap.vue
    setMap: (state, map) => {
      state.webmap = map;
    },
  },

  /*
    Actions are similar to mutations, the differences being that:
    Instead of mutating the state, actions commit mutations.
    Actions can contain arbitrary asynchronous operations.
  */

  // Based on the URL built from form, gets data from API to build graph
  actions: {
    /* OVERHAUL NEW ACTIONS */
    // Initial Metadata - used in main.js
    storeCables: ({ commit }, { cables }) => {
      commit('STORE_CABLES', cables);
    },
    storeInstruments: ({ commit }, { instruments }) => {
      commit('STORE_INSTRUMENTS', instruments);
    },
    storeSites: ({ commit }, { sites }) => {
      commit('STORE_SITES', sites);
    },
    storeInfrastructures: ({ commit }, { infras }) => {
      const modifiedInfras = infras.map((infra) => ({ ...infra, infraName: infra.name.replace(/ *\([^)]*\) */g, '') }));
      commit('STORE_INFRAS', modifiedInfras);
    },
    storeAreas: ({ commit }, { areas }) => {
      commit('STORE_AREAS', areas);
    },
    storeParameters: ({ commit }, { parameters }) => {
      commit('STORE_PARAMETERS', parameters);
    },
    storeGlobalRanges: ({ commit }, { globalRanges }) => {
      commit('STORE_GLOBAL_RANGES', globalRanges);
    },
    storeInstrumentStatus: ({ commit }, { statusIndicators }) => {
      commit('STORE_INSTRUMENT_STATUS', statusIndicators);
    },
    storeInfrastructureStatus: ({ commit }, { infraIndicators }) => {
      commit('STORE_INFRASTRUCTURE_STATUS', infraIndicators);
    },
    storeInstrumentsCatalog: ({ commit }, { instrumentsCatalog }) => {
      commit('STORE_INSTRUMENTS_CATALOG', instrumentsCatalog);
    },
    storeSpriteIcons: ({ commit }, { spriteIcons }) => {
      commit('STORE_SPRITE_ICONS', spriteIcons);
    },
    storeDataPortalPosts: ({ commit }, { dataPortalPosts }) => {
      commit('STORE_DATA_PORTAL_POSTS', dataPortalPosts);
    },
    updateProgress: ({ commit, state }, { val }) => {
      const newVal = state.progressVal + val;
      commit('UPDATE_PROGRESS', newVal);
    },

    // Map Interactions - used in WebMap.vue
    mapSelectInfrastructure: ({ commit }, { infrastructure }) => {
      commit('MAP_SELECT_INFRA', infrastructure);
    },
    mapSelectInst: ({ commit }, { instrument }) => {
      commit('MAP_SELECT_INST', instrument);
    },
    setInstrumentModals: ({ commit }, { refs }) => {
      commit('SET_INSTRUMENT_MODALS', { ...refs });
    },
    setInfraDetailsContent: ({ commit }, { wpContent }) => {
      commit('SET_INFRA_WP_CONTENT', wpContent);
    },
    setSelectedInfra: ({ commit }, { selected }) => {
      commit('SET_SELECTED_INFRA', selected);
    },
    toggleSidebar: ({ commit }, { showSidebar }) => {
      commit('TOGGLE_SIDEBAR', showSidebar);
    },
    determineSidebarContent: ({ commit }, { sidebarContent }) => {
      commit('DETERMINE_SIDEBAR_CONTENT', sidebarContent);
    },
    setSelectedInstrument: ({ commit }, { selected }) => {
      commit('SET_SELECTED_INSTRUMENT', selected);
    },
    setCurrentBasemapScheme: ({ commit }, { scheme }) => {
      commit('SET_CURRENT_BASEMAP_SCHEME', scheme);
    },
    setBathymetryInView: ({ commit }, { layers }) => {
      commit('SET_BATHYMETRY_IN_VIEW', layers);
    },
    async getInfraWPContent({ dispatch, state }) {
      await axios
        .get(
          `${process.env.OOIURL}/wp-json/wp/v2/pages/${state.mapSelectedInfra.properties.wp_mapping}`,
        )
        .then((response) => {
          dispatch('setInfraDetailsContent', { wpContent: response.data });
        });
    },
    // Map Interactions - used in basemaps.vue
    setSelectedBathymetryLayers: ({ commit }, { selected }) => {
      commit('SET_BATHYMETRY_LAYERS', selected);
    },

    // App load state
    setLoaded: ({ commit }) => {
      commit('APP_LOADED');
    },
    setNotLoaded: ({ commit }) => {
      commit('APP_NOT_LOADED');
    },
    /* END */
  },
});

export default store;
